module.exports = __webpack_public_path__ + "static/media/magpieBanner_sm3.a0b6a485.png";